export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n) || 0);

const fmt = (tz, opts) => new Intl.DateTimeFormat("en-US", { timeZone: tz, ...opts });

export const dayKey = (iso, tz) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(iso));
export const fmtTime = (iso, tz) => fmt(tz, { hour: "numeric", minute: "2-digit" }).format(new Date(iso));
export const fmtDate = (iso, tz) => fmt(tz, { weekday: "short", month: "short", day: "numeric" }).format(new Date(iso));
export const fmtDateTime = (iso, tz) => `${fmtDate(iso, tz)} · ${fmtTime(iso, tz)}`;
export const keyToDate = (k) => {
  const [y, m, d] = k.split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const fmtDay = (k) => (k ? keyToDate(k.slice(0, 10)).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");
export const todayKey = (tz) => dayKey(new Date().toISOString(), tz);

export function toLocalInput(iso, tz) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(new Date(iso));
  const p = Object.fromEntries(parts.map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}

export const SERVICE_LABELS = { standard: "Standard clean", deep: "Deep clean", move: "Move-in/out", other: "Other" };
export const METHOD_LABELS = { cash: "Cash", check: "Check", bank_transfer: "Bank transfer", online: "Online" };
export const STATUS_LABELS = {
  requested: "Requested", confirmed: "Confirmed", in_progress: "In progress", completed: "Completed", canceled: "Canceled",
  draft: "Draft", sent: "Sent", approved: "Approved", declined: "Declined", converted: "Converted",
  unpaid: "Unpaid", partially_paid: "Partially paid", paid: "Paid", overdue: "Overdue", void: "Void",
  failed: "Failed", skipped: "Skipped", not_sent: "Not sent",
};

export function computeTotals(items, discountType, discountValue, taxRate) {
  const r = (x) => Math.round((x + Number.EPSILON) * 100) / 100;
  const subtotal = r(items.reduce((s, i) => s + r((Number(i.quantity) || 0) * (Number(i.unit_price) || 0)), 0));
  const dv = Number(discountValue) || 0;
  const discount = discountType === "percent" ? r((subtotal * Math.min(dv, 100)) / 100) : r(Math.min(dv, subtotal));
  const tax = r(((subtotal - discount) * (Number(taxRate) || 0)) / 100);
  return { subtotal, discount, tax, total: r(subtotal - discount + tax) };
}
